module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "inp-input",
    class: {
      'error': _vm.error
    }
  }, [_c('input', {
    staticClass: "input pl-2",
    attrs: {
      "type": "date",
      "required": _vm.required,
      "disabled": _vm.disabled,
      "placeholder": " "
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "focus": function($event) {
        _vm.focus($event)
      },
      "change": function($event) {
        _vm.change($event)
      },
      "paste": function($event) {
        _vm.paste($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-208195b7"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/InputDate/input-date.vue.html
// module id = lVFT
// module chunks = 2